/** Where theapp.js was loaded from — the CDN for visitors, localhost in dev mode (?theapp_dev=1). Read while the script
 *  runs: document.currentScript is null once it has finished. Sibling files (theapp-carousel.js) load from the same place
 *  with the same query string, so the dev cache-buster carries over and CDN URLs stay clean. */
const src = document.currentScript instanceof HTMLScriptElement ? document.currentScript.src : '';
const q = src.indexOf('?');
const path = q < 0 ? src : src.slice(0, q);

export const BUNDLE = {
  base: path.includes('/') ? path.slice(0, path.lastIndexOf('/')) : __THEAPP_CDN__,
  query: q < 0 ? '' : src.slice(q),
};
